import React from "react";
import { EntityCrudPage } from "./EntityCrudPage";

export function BrandsPage() {
  return (
    <EntityCrudPage
      title="Brands"
      subtitle="Manage brand logos and links for customers."
      endpoint="/api/Brands"
      customerScoped
      listColumns={[
        { key: "image", label: "Image", type: "image" },
        { key: "name", label: "Name" },
        { key: "link", label: "Link", oneLine: true },
        { key: "description", label: "Description", oneLine: true },
        { key: "customerName", label: "Customer" }
      ]}
      fields={[
        { key: "name", label: "Name", required: true },
        { key: "image", label: "Image", type: "image" },
        { key: "link", label: "Link" },
        { key: "description", label: "Description", type: "textarea" }
      ]}
    />
  );
}
